const routes = [
	{
		path: '/',
		component: () => import('layouts/MainLayout.vue'),
		children: [
			{ path: '', component: () => import('pages/IndexPage.vue') },
			{ path: 'picmysix', component: () => import('pages/PickMy6.vue') },
			{ path: 'fixture', component: () => import('pages/fixture/FixturePage.vue') },
			{ path: '/fixture-detail/:fixtureId/:teamId', component: () => import('pages/fixture/FixtureDetail.vue') },
			{ path: 'leaderboard', component: () => import('src/pages/Leaderboard/LeaderboardScreen.vue') },
			{ path: 'myAccount', component: () => import('src/pages/MyAccount/MyAccount.vue') },
			{ path: 'share/:shareCode', component: () => import('src/pages/Referral/Referral.vue') },
		]
	},

	// Always leave this as last one,
	// but you can also remove it
	{
		path: '/:catchAll(.*)*',
		component: () => import('pages/ErrorNotFound.vue')
	}
]

export default routes
